import type { TransformedVideo, VideoFromBackend, VideosFromBackend } from './types';

export function transformVideos(
  videos: VideosFromBackend,
): TransformedVideo {
  return videos.data.map(({ attributes }) => createVideoData(attributes))[0];
}

function createVideoData(
  attributes?: VideoFromBackend['attributes'],
) {
  const title = attributes?.title || '';
  const video = attributes?.video?.data?.attributes?.url || '';
  const preview = attributes?.preview?.data?.attributes?.url || '';

  return { preview, video, title };
}
